import React from 'react';
import { Navigation } from '../components/Navigation';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { CredentialsSection } from '../components/CredentialsSection';
import { SpecialtySection } from '../components/SpecialtySection';
import { PortfolioCarousel } from '../components/PortfolioCarousel';
import { ProcessSection } from '../components/ProcessSection';
import { TestimonialsCarousel } from '../components/TestimonialsCarousel';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
import { LanguageGate } from '../components/LanguageGate';
export function LandingPage() {
  return <div className="min-h-screen bg-brand-black text-brand-white font-sans" data-id="element-193">
      <LanguageGate data-id="element-194">
        <Navigation data-id="element-195" />
        <main data-id="element-196">
          <div id="hero" data-id="element-197">
            <HeroSection data-id="element-198" />
          </div>
          <div id="about" data-id="element-199">
            <AboutSection data-id="element-200" />
          </div>
          <div id="portfolio" data-id="element-201">
            <PortfolioCarousel data-id="element-202" />
          </div>
          <div id="credentials" data-id="element-203">
            <CredentialsSection data-id="element-204" />
          </div>
          <div id="specialty" data-id="element-205">
            <SpecialtySection data-id="element-206" />
          </div>
          <div id="process" data-id="element-207">
            <ProcessSection data-id="element-208" />
          </div>
          <div id="testimonials" data-id="element-209">
            <TestimonialsCarousel data-id="element-210" />
          </div>
          <div id="contact" data-id="element-211">
            <CTASection data-id="element-212" />
          </div>
        </main>
        <Footer data-id="element-213" />
      </LanguageGate>
    </div>;
}